<template>
  <ToolKits />
</template>

<script>
// @ is an alias to /src
import ToolKits from "@/components/ToolKits.vue";

export default {
  name: "HomeView",
  components: {
    ToolKits,
  },
};
</script>
